/**
 * Static Pages Configuration
 *
 * This file defines the structure and content of static pages in the application.
 * It contains configuration for various pages including About Us, Gallery, and other informational pages.
 *
 * Each page configuration includes:
 * - Title and navigation settings
 * - Content structure with sections
 * - Support for different content types (text, images, mixed content)
 * - Responsive image handling
 * - Internationalization support
 */

export const pages = {
  about: {
    title: "About Us",
    path: "/pages/about",
    showInNav: true,
    navOrder: 1,
    content: {
      heading: "About Us",
      // subtitle: "Learn more about what we do", // optional
      sections: [
        // Text Section Example
        {
          type: "text",
          // title: "Communities", // optional
          // subtitle: "What drives us forward", // optional
          content: [
            {
              text: "Silanga.ca is brought to you by Silanniarviit, an Inuit-led group of community weather station network managers in Nunavut. The Silanniarviit share this website and other resources to help promote the use of community weather information. Currently, we are involved with 6 communities: Igloolik, Arctic Bay, Pond Inlet, Grise Fiord, Iqaluit and Sanirajak (coming soon). Our weather station sites were chosen by community members for their own benefit. We train local technicians to deploy and maintain our stations, which are meant to complement Inuit knowledge and other weather information available at [[windy.com|https://www.windy.com/|external]], [[Environment Canada|https://weather.gc.ca/|external]], [[SIKU|https://siku.org/|external]] and elsewhere. On Silanga, we display government and some research weather stations in Nunavut as well.",
            },
            {
              text: "We are inspired by the Clyde River weather station network ([[https://clyderiverweather.org/|https://clyderiverweather.org/|external]]) run by [[Ittaq Heritage and Research Centre|https://ittaq.ca/|external]], and community weather stations in [[Labrador|https://www.labradorgeolab.ca/weather|external]].",
            },
          ],
        },
        {
          type: "image",
          title: "",
          subtitle: "",
          image: require("./images/Nuvuit_DSC_8163.jpg"),
          caption: "Sun setting behind the Nuvuit weather station",
          imagePosition: "center",
          imageStyle: "cover", // Options: 'cover', 'contain', 'fill', 'none', 'scale-down'
          imageFit: {
            width: "100%", // Optional: custom width
            maxWidth: "800px", // Optional: custom max width
            height: "auto", // Optional: custom height
            maxHeight: { xs: "300px", md: "500px" }, // Optional: responsive max height
          },
        },
        {
          type: "text",
          title: "", // optional
          subtitle: "", // optional
          content: [
            {
              text: "The weather information displayed here belongs to the community that maintain the stations.  It is provided on a best-effort basis and the preliminary data has not been quality-controlled and we can’t guarantee these systems will work perfectly 100% of the time.",
            },
          ],
        },
        {
          type: "text",
          title:
            "If you have questions or comments about the stations, please contact:", // optional
          subtitle: "", // optional
          content: [
            {
              text: "• Travis Qaunaq (iglooliksilanga@gmail.com) for the Igloolik Hunters and Trappers Association",
            },
            {
              text: "• Andrew Arreak (mittimataliksilanga@gmail.com) for Sikumiut Community Management Committee, SmartICE in Pond Inlet",
            },
            {
              text: "• Sheena Shappa (arcticbayweather@gmail.com) for Ikajutit Hunters and Trappers Association in Arctic Bay",
            },
            {
              text: "• Terry Noah (asiqsilanga@gmail.com) for Ausuittuup Sigjanik Imanganik Qaujisarniq (ASIQ), Grise Fiord",
            },
            {
              text: "• Sean Qappik (nrisilanga@gmail.com) Nunavut Research Institute, Iqaluit",
            },
            {
              text: "• Daniel Taukie (ntisilanga@gmail.com) Nunavut Tunngavik Incorporated, Iqaluit",
            },
            {
              text: "• Thomasie Issigaitok (sanirajaksilanga@gmail.com) for Hall Beach Hunters and Trappers Association in Sanirajak (weather stations coming in August 2026)",
            },
          ],
        },
        // // Image Grid Example
        // {
        //   type: "imageGrid",
        //   title: "Gallery", // optional
        //   // subtitle: "Recent projects", // optional
        //   gridCols: 3, // optional, default: 3
        //   images: [
        //     // {
        //     //   img: require("./images/Tuqqajaat_DSC_8740.jpg"),
        //     //   title: "The Tuqqajaat weather station", // optional
        //     //   // subtitle: "Phase 1", // optional
        //     //   author: "Photo: A Loewen", // optional
        //     //   // cols: 2, // optional
        //     //   // rows: 2, // optional
        //     // },
        //     {
        //       img: require("./images/Nuvuit_DSC_8163.jpg"),
        //       title: "Sun setting behind the Nuvuit weather station", // optional
        //       // subtitle: "Phase 1", // optional
        //       author: "Photo: D Mueller", // optional
        //       cols: 2, // optional
        //       rows: 2, // optional
        //     },
        //     {
        //       img: require("./images/Qikiqtatannak.jpg"),
        //       title: "The Qikiqtatannak weather station", // optional
        //       // subtitle: "Phase 1", // optional
        //       author: "Photo: A Loewen", // optional
        //       cols: 1, // optional
        //       rows: 2, // optional
        //     },
        //     {
        //       img: require("./images/Ivisaaruqtuuq_20230520_184625.jpg"),
        //       title: "Setting up Ivisaaruqtuuq weather station", // optional
        //       // subtitle: "Phase 1", // optional
        //       author: "Photo: D Mueller", // optional
        //       // cols: 2, // optional
        //       // rows: 2, // optional
        //     },
        //     {
        //       img: require("./images/Aqigiliq_DSC_7503.jpg"),
        //       title:
        //         "Camille Lavallee attaches the instrument wires to the enclosure of the Agigiliq weather station", // optional
        //       // subtitle: "Phase 1", // optional
        //       author: "Photo: A Loewen", // optional
        //       // cols: 1, // optional
        //       // rows: 1, // optional
        //     },
        //   ],
        // },
        // {
        //   type: "text",
        //   title: "", // optional
        //   subtitle: "", // optional
        //   content: [
        //     {
        //       text: "We are also working with community representatives to develop TV displays that can be used to show the same weather information that is available on this website in publicly accessible areas such as Hamlet and HTO offices.",
        //     },
        //   ],
        // },
        // Single Image Example
        {
          type: "image",
          title: "",
          subtitle: "",
          image: require("./images/TV-kiosk.png"),
          caption: "A map from the TV display we are developing",
          imagePosition: "center",
          imageStyle: "cover", // Options: 'cover', 'contain', 'fill', 'none', 'scale-down'
          imageFit: {
            width: "100%", // Optional: custom width
            maxWidth: "800px", // Optional: custom max width
            height: "auto", // Optional: custom height
            maxHeight: { xs: "300px", md: "500px" }, // Optional: responsive max height
          },
        },
        {
          type: "text",
          title: "", // optional
          subtitle: "", // optional
          content: [
            {
              text: "Silanniarviit is supported by researchers at the Water and Ice Research Lab ([[WIRL|https://wirl.carleton.ca/|external]]) at Carleton University, the Straight Up North ([[SUN|https://straightupnorth.ca/|external]]) Team at McMaster University and the Laboratoire d'études des Littoraux Nordiques et Arctiques ([[LNAR|https://www.lnar.ca/|external]]) at Université du Québec à Rimouski. The community and research weather stations are based on WIRL's Automatic Weather Station design.",
            },
            {
              text: "Translation: Malachi Arreak",
            },
            {
              text: "Web design: Krish Dhirubhai, WIRL",
            },
            {
              text: "[[Silanga Admin|/kiosk|external]]",
            },
          ],
        },

        {
          type: "image",
          // title: "Partners and Funding",
          subtitle: "Partners and Funding",
          image: require("./images/Partners and Funding.png"),
          // caption: "Partners and Funding",
          imagePosition: "center",
          imageStyle: "cover", // Options: 'cover', 'contain', 'fill', 'none', 'scale-down'
          imageFit: {
            width: "100%", // Optional: custom width
            maxWidth: "800px", // Optional: custom max width
            height: "auto", // Optional: custom height
            maxHeight: { xs: "300px", md: "500px" }, // Optional: responsive max height
          },
        },

        // Mixed Content Example
        // {
        //   type: "mixed",
        //   title: "Latest Updates", // optional
        //   subtitle: "What's new", // optional
        //   content: [
        //     {
        //       type: "text",
        //       text: "Recent developments",
        //       links: [
        //         // optional
        //         {
        //           text: "Read more",
        //           url: "/blog",
        //           external: false,
        //         },
        //       ],
        //     },
        //     {
        //       type: "image",
        //       image: require("./images/Aqigiliq_DSC_7503.jpg"),
        //       caption: "Team meeting", // optional
        //       author: "Mike Wilson", // optional
        //     },
        //   ],
        // },
      ],
    },
  },
  // gallery: {
  //   title: "Gallery",
  //   path: "/pages/gallery",
  //   showInNav: true,
  //   navOrder: 2,
  //   content: {
  //     heading: "Gallery",
  //     // subtitle: "Learn more about what we do", // optional
  //     sections: [
  //       // Text Section Example
  //       // Image Grid Example
  //       {
  //         type: "imageGrid",
  //         title: "Weather Stations", // optional
  //         // subtitle: "Recent projects", // optional
  //         gridCols: 3, // optional, default: 3
  //         images: [
  //           // {
  //           //   img: require("./images/Tuqqajaat_DSC_8740.jpg"),
  //           //   title: "The Tuqqajaat weather station", // optional
  //           //   // subtitle: "Phase 1", // optional
  //           //   author: "Photo: A Loewen", // optional
  //           //   // cols: 2, // optional
  //           //   // rows: 2, // optional
  //           // },
  //           {
  //             img: require("./images/Nuvuit_DSC_8163.jpg"),
  //             title: "Sun setting behind the Nuvuit weather station", // optional
  //             // subtitle: "Phase 1", // optional
  //             author: "Photo: D Mueller", // optional
  //             cols: 2, // optional
  //             rows: 2, // optional
  //           },
  //           {
  //             img: require("./images/Qikiqtatannak.jpg"),
  //             title: "The Qikiqtatannak weather station", // optional
  //             // subtitle: "Phase 1", // optional
  //             author: "Photo: A Loewen", // optional
  //             cols: 1, // optional
  //             rows: 2, // optional
  //           },
  //           {
  //             img: require("./images/Ivisaaruqtuuq_20230520_184625.jpg"),
  //             title: "Setting up Ivisaaruqtuuq weather station", // optional
  //             // subtitle: "Phase 1", // optional
  //             author: "Photo: D Mueller", // optional
  //             // cols: 2, // optional
  //             // rows: 2, // optional
  //           },
  //           {
  //             img: require("./images/Aqigiliq_DSC_7503.jpg"),
  //             title:
  //               "Camille Lavallee attaches the instrument wires to the enclosure of the Agigiliq weather station", // optional
  //             // subtitle: "Phase 1", // optional
  //             author: "Photo: A Loewen", // optional
  //             // cols: 1, // optional
  //             // rows: 1, // optional
  //           },
  //         ],
  //       },
  //     ]}}
};
